
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { UseFormRegister } from "react-hook-form";
import { ResourceFormData } from "./types";

interface ResourceFormFieldsProps {
  register: UseFormRegister<ResourceFormData>;
}

export function ResourceFormFields({ register }: ResourceFormFieldsProps) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor="topic">Topic</Label>
          <Input
            id="topic"
            {...register("topic", { required: true })}
            placeholder="Enter topic"
            className="w-full"
          />
        </div>
        
        <div className="space-y-1">
          <Label htmlFor="company">Company</Label>
          <Input
            id="company"
            {...register("company", { required: true })}
            placeholder="Enter company name"
            className="w-full"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor="primaryColor">Primary Color</Label>
          <Input
            id="primaryColor"
            type="color"
            {...register("primaryColor", { required: true })}
            className="h-8 w-full cursor-pointer"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="secondaryColor">Secondary Color</Label>
          <Input
            id="secondaryColor"
            type="color"
            {...register("secondaryColor", { required: true })}
            className="h-8 w-full cursor-pointer"
          />
        </div>
      </div>

      <div className="space-y-1">
        <Label htmlFor="logo">Logo</Label>
        <Input
          id="logo"
          type="file"
          accept="image/*"
          {...register("logo")}
          className="w-full cursor-pointer"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor="companyInfo">Company Information</Label>
          <Textarea
            id="companyInfo"
            {...register("companyInfo")}
            placeholder="Enter company information"
            className="w-full min-h-[60px] max-h-[100px] resize-none"
          />
        </div>

        <div className="space-y-1">
          <Label htmlFor="additionalInfo">Additional Information</Label>
          <Textarea
            id="additionalInfo"
            {...register("additionalInfo")}
            placeholder="Enter additional information"
            className="w-full min-h-[60px] max-h-[100px] resize-none"
          />
        </div>
      </div>
    </>
  );
}
